
export enum ResearchReminderType {
  AfterInvite = 0,
  BeforeDeadline = 1
}
